import { collection, onSnapshot, query } from "@firebase/firestore";
import React, { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import CardProf from "../../../Component/cardProf/CardProf";
import PaginationContainer from "../../../Component/PaginationContainer/PaginationContainer";
import { db } from "../../../Firebase";
import MonBtn from "../../Commun/Btnbtn/MonBtn";

function Archive() {
  const [allArchive, setAllArchive] = useState([]);
  const { user_type } = useParams();

  const reftab = query(collection(db, "users"));
  const getUsers = () => {
    onSnapshot(reftab, (item) => {
      const currentUserId = sessionStorage.getItem("user_id");
      const data = [];
      item.forEach((i) => {
        data.push({ ...i.data(), id: i.id });
      });

      setAllArchive(
        data.filter(
          (elts) =>
            elts.user_type === user_type &&
            elts.admin_id === currentUserId &&
            elts.isArchived
        )
      );
    });
  };

  useEffect(() => {
    getUsers();
  }, []);

  const [filter, setFilter] = useState("");

  const handelChange = (e) => {
    setFilter(e.target.value);
  };

  return (
    <div>
      <Container>
        <div  className="d-flex" >
          <MonBtn>Mes donnnes</MonBtn>
          <div className="d-flex justify-content-end ajouRecher  ms-auto w-25">
            <input
              type="text"
              onChange={handelChange}
              value={filter}
              className="form-control"
              id="exampleInputEmail1"
              placeholder={`Recherche ${user_type}`}
              aria-describedby="emailHelp"
            />
          </div>
        </div>
        <Row>
            <PaginationContainer data={allArchive} ItemComponent={CardProf}/>
        </Row> 
      </Container>
    </div>
  );
}

export default Archive;
